import { queryOptions } from "@tanstack/react-query";
import type {
  PaginatedResponse,
  CustomerDto,
  CustomerId,
  User,
} from "@yalana/contracts";
import { fetchApi } from "../infrastructure/api-client";

export const customersQueries = {
  all: () => ["customers"] as const,
  list: () =>
    queryOptions({
      queryKey: [...customersQueries.all(), "list", { pageSize: 500 }] as const,
      queryFn: async () => {
        const res = await fetchApi<PaginatedResponse<CustomerDto>>(
          "/api/customers?page=1&pageSize=500",
          { skipRedirect: true },
        );
        return res.data;
      },
    }),

  detail: (id: CustomerId) =>
    queryOptions({
      queryKey: [...customersQueries.all(), id] as const,
      queryFn: () => fetchApi<CustomerDto>(`/api/customers/${id}`),
    }),
  users: (customerId: CustomerId) =>
    queryOptions({
      queryKey: [...customersQueries.all(), customerId, "users"] as const,
      queryFn: () => fetchApi<User[]>(`/api/customers/${customerId}/users`),
    }),
};
